import script from "./CartItemRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItemRow.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__